
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"17","viewBox":"0 0 18 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.087 3.408L14.588.911a.83.83 0 00-.59-.244H4a.83.83 0 00-.588.244L.913 3.408A.828.828 0 00.667 4v10.834c0 .92.746 1.667 1.666 1.667h13.334c.92 0 1.666-.747 1.666-1.667V4c0-.23-.094-.44-.246-.59zM4.345 2.333h9.31l.833.834H3.512l.833-.834zm8.822 7.5v.834H4.832V7.333H6.5V9h5V7.333h1.666v2.5z","fill":"#2663D0"}})])
          )
        }
      }
    